<template>

  <div class="card p-3">
    <div class="grid">

      <!-- Titulo Oficios -->
      <div class="col-9 xl:col-3 lg:col-3 md:col-4 sm:col-7 p-2 flex justify-content-end">
        <h5 class="p-2 mt-2 tablaTitle">
          <i
              class="fa-solid fa-box-archive fa-shake px-2"
              style="--fa-animation-iteration-count: 1; --fa-animation-duration: 2.5s;"
          ></i>
          Oficios cancelados
        </h5>
      </div>
      <!-- Titulo Oficios -->

      <div class="col-3 xl:col-2 lg:col-7 md:col-8 sm:col-5 flex justify-content-start">
        <!-- <dialogArchivarOficios/> -->
      </div>

      <div class="col-0 xl:col-7 lg:col-7 md:col-0 sm:col-0 p-2"></div>

      <!-- Tabs -->
      <div class="col-12 p-2">
        <div class="card">

          <TabViewVue
              class="tabview-custom tabsTablas"
              :activeIndex="parseInt(selectedTab)"
          >

  <TabPanelVue>
    <template #header>

      <div class="grid titulosPestanas" >
        <div class="col-12 text-center">
          <!-- Contador para oficios -->
          <BadgeVue
              :value="contadorOficiosCancelados"
              class="titulosPestanasContador">
          </BadgeVue>
          <!-- Contador para oficios -->
          <i
              class="fa-solid fa-folder-open fa-tags px-2"
              style="--fa-animation-iteration-count: 1; --fa-animation-duration: 2.5s;"
          ></i>
          <span>Oficios cancelados</span>
        </div>
      </div>

    </template>

      <div class="card p-3">
          <div class="grid">

              <!-- Titulo Oficios -->
              <div class="col-9 xl:col-3 lg:col-3 md:col-4 sm:col-7 p-2 flex justify-content-end">
                  <h5 class="p-2 mt-2 tablaTitle">
                      <i class="fa-solid fa-box-archive fa-shake px-2"
                          style="--fa-animation-iteration-count: 1; --fa-animation-duration: 2.5s;"></i>
                      Oficios cancelados
                  </h5>
              </div>
          </div>
          <div class="card p-1">
              <DataTable :value="dataApi" responsiveLayout="scroll" v-model:filters="filters" :loading="loading"
                  stripedRows sortField="numeroOficio" :sortOrder="-1" :paginator="true" :rows="10"
                  paginatorTemplate="CurrentPageReport  PrevPageLink PageLinks NextPageLink  RowsPerPageDropdown"
                  :rowsPerPageOptions="[10, 20, 30]" removableSort dataKey="numeroOficio" class="p-datatable-sm"
                  style="width: 100%">

                  <template #header>
                      <div class="grid">

                          <div class="col-12 p-2">
                              <div class="flex justify-content-center">
                                  <span class="p-input-icon-left m-2">
                                      <i class="pi pi-search" />
                                      <InputTextV v-model="filters['global'].value" placeholder="Buscar"
                                          class="p-inputtext-sm" />
                                  </span>
                              </div>
                          </div>

                      </div>
                  </template>
                  <ColumnVue v-for="col of columnsAlt" :field="col.field" :header="col.header" :key="col.field"
                      :sortable="true" :hidden="col.hidden" class="border-dashed border-300 tablaOficiosData">
                  </ColumnVue>
              </DataTable>
          </div>
      </div>
  </TabPanelVue>
          </TabViewVue>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { ref } from 'vue';
import api from "@/api/laravelApi";
import DataTable from "primevue/datatable";
import { FilterMatchMode } from "primevue/api";
// import dialogArchivarOficios from "@/modules/oficialia/components/oficiosLibres/dialogAyudaArchivarOficios.vue";
import {useRoute} from "vue-router";
import Swal from 'sweetalert2';

export default {
    name: 'CanceladosOficios',
    components: {
      // dialogArchivarOficios,
        DataTable,
    },
    data() {
        const route = useRoute();
        const selectedTab = ref(route.params.tab);
        const contadorOficiosCancelados = ref(0);
        let data = ref([]);
        let loading = ref(true);
        let filters = ref({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        });
        const columnsAlt = ref([
            { field: "numeroOficio", header: "Número oficio" },
            { field: "fechaCreacion", header: "Fecha creación" },
            { field: "asunto", header: "Asunto" },

            { field: "fechaOficio", header: "Fecha Formato", hidden: true },
            { field: "ciudadFecha", header: "Fecha Municipio", hidden: true },
            { field: "nota", header: "Nota", hidden: true },
            { field: "expediente", header: "Expediente", hidden: true },
            { field: "idLeyenda", header: "Leyenda", hidden: true },
            { field: "cuerpo", header: "Cuerpo", hidden: true },

            { field: "status", header: "id_estado", hidden: true },
            { field: "idOficio", header: "idOficio", hidden: true },
            { field: "adjuntado", header: "adjuntado", hidden: true },

            { field: "dependenciaFirmante", header: "Dependencia que envía" },
            {
                field: "subdependenciaFirmante",
                header: "subdependenciaFirmante",
                hidden: true,
            },
            { field: "oficinaFirmante", header: "Oficina que envía" },
            { field: "firmante", header: "Remitente" },
        ]);

        return {
            dataApi: data,
            columnsAlt,
            loading,
            filters,
            selectedTab,
            contadorOficiosCancelados,
        }

    },
    mounted() {
      this.loadCount();
      new Swal({
        title: "Cargando...",
        text: "Actualizando información de oficios cancelados",
        allowOutsideClick: false,
      });
      Swal.showLoading();
      api.get("oficios/listaCancelados")
          .then((response) => {
            this.dataApi = response.data?.data || [];
            this.loading = false;
            Swal.close()
          })
          .catch((err) => {
            new Swal({
              title: "Error",
              text: err,
              allowOutsideClick: false,
            });
          });
          
    },
    methods: {
      async loadCount() {
        const data = localStorage.getItem("cantidadOficios");
        if (data) {
          try {
            const parsedData = JSON.parse(data);
            this.contadorOficiosCancelados = parsedData.oficios_cancelados; // ✅ Asignación correcta
          } catch (error) {
            new Swal({
              title: "Error",
              icon: error,
              text:error,
              allowOutsideClick: false,
            });
          }
        }
      }
    }
}
</script>
<style scoped lang="scss"></style>
